import React, { useState } from "react";
import { motion } from "framer-motion";
import Contact_img from "../Assest/images/contact page.webp";
import hero1 from "../Assest/images/contact page.webp";
import toast, { Toaster } from "react-hot-toast";
import { FaEnvelope, FaPhone } from "react-icons/fa";
import axios from "axios";

const Contact = () => {
  const [isSmsAgreed, setIsSmsAgreed] = useState(false);
  const [appointmentdata, setAppointmentdata] = useState({
    email: '',
    companyId: 65,
    date: new Date().toISOString().split('T')[0],
    time: new Date().toLocaleTimeString(),
  })

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    companyId: 65
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleAppointmentChange = (e) => {
    setAppointmentdata({ ...appointmentdata, [e.target.name]: e.target.value });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URI}/contact/create`, formData);
      console.log(response.data);
      toast.success("Your message has been received. We will contact you shortly.");

      setFormData({
        name: '',
        email: '',
        subject: '',
        message: '',
        companyId: 65
      });

    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
      toast.error("Failed to create contact");
    }
  };

  const handleAppointmentSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URI}/appointment/create`, appointmentdata);
      console.log(response.data);
      toast.success("Your appointment has been successfully scheduled.");

      setAppointmentdata({
        email: '',
        companyId: 65,
        date: new Date().toISOString().split('T')[0],
        time: new Date().toLocaleTimeString(),
      });

    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
      toast.error("Failed to create contact");
    }
  };


  return (
    <div className="w-full overflow-hidden">
      {/* Hero Section with Background Image */}
      <section className="w-full h-[500px] relative mt-16">
        <motion.div
          key={1}
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="w-full h-full"
        >
          {/* Background Image */}
          <img
            src={Contact_img}
            alt="Background"
            className="w-full h-full object-cover"
          />

          {/* Overlay */}
          <div className="absolute inset-0 bg-black/50"></div>

          {/* Centered Content */}
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center z-10 px-4">
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="text-4xl md:text-6xl font-bold mb-4 text-orange-500" // Yahan color change kiya hai
            >
              Contact Our Team
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="text-lg md:text-xl text-gray-200 max-w-xl"
            >
              We’re here to ensure your grocery and household needs are met with quality and care.
            </motion.p>
          </div>
        </motion.div>
      </section>

      {/* Main Content Container */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-16 space-y-16">
        {/* Form and Newsletter Section */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Contact Form */}
          <div className="lg:col-span-2">
            <form className="space-y-4" onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <input
                  onChange={handleChange}
                  value={formData.name}
                  type="text"
                  placeholder="Name"
                  name='name'
                  className="w-full p-3 rounded-md bg-orange-50 border-0 outline-none focus:outline-none focus:ring-2 focus:ring-orange-500 focus-visible:ring-orange-500 focus:border-transparent"
                />
                <input
                  onChange={handleChange}
                  value={formData.email}
                  type="email"
                  required
                  name="email"
                  placeholder="Email"
                  className="w-full p-3 rounded-md bg-orange-50 border-0 outline-none focus:outline-none focus:ring-2 focus:ring-orange-500 focus-visible:ring-orange-500 focus:border-transparent"
                />
              </div>
              <input
                onChange={handleChange}
                value={formData.subject}
                name="subject"
                type="text"
                required
                placeholder="Subject"
                className="w-full p-3 rounded-md bg-orange-50 border-0 outline-none focus:outline-none focus:ring-2 focus:ring-orange-500 focus-visible:ring-orange-500 focus:border-transparent"
              />
              <textarea
                onChange={handleChange}
                placeholder="Message"
                value={formData.message}
                name="message"
                rows="4"
                required
                className="w-full p-3 rounded-md bg-orange-50 border-0 outline-none focus:outline-none focus:ring-2 focus:ring-orange-500 focus-visible:ring-orange-500 focus:border-transparent"
              />
              {/* SMS Compliance Checkbox */}
              <div className="mt-4">
                <label className="flex items-start gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    required
                    className="mt-1 w-4 h-4 text-orange-500 border-gray-300 rounded focus:ring-orange-500"
                    checked={isSmsAgreed}
                    onChange={(e) => setIsSmsAgreed(e.target.checked)}
                  />
                  <span className="text-sm text-gray-700">
                    I agree to receive SMS communications from VitalSource WholeSale LLC DBA American Vent Care.
                    <br />
                    <span className="text-xs">
                      Read our <a href="/privacy-policy" className="text-orange-600 underline">Privacy Policy</a> and <a href="/terms-conditions" className="text-orange-600 underline">Terms & Conditions</a>.
                    </span>
                  </span>
                </label>
              </div>

              {/* Compliance Disclosure Text */}
              <p className="mt-4 text-xs text-gray-500 italic">
                By providing your phone number and opting into SMS communications, you consent to receive text messages from VitalSource Wholesale LLC, including but not limited to:

                Delivery Notifications – Updates regarding the shipment and delivery status of your orders
                Order Confirmations – Confirmation of purchases and transactions
                Customer Support – Responses to inquiries submitted through our website
                Service Updates – Important updates related to your account or our services

              </p>
              <button
                type="submit"
                className="px-6 py-3 bg-orange-500 text-white rounded-md hover:bg-orange-700 transition-colors"
              >
                Submit Button
              </button>
            </form>
          </div>

          {/* Newsletter */}
          <div className="relative bg-orange-100 p-6 rounded-lg text-gray-800 overflow-hidden">
            {/* Background Image with Overlay */}
            <div className="absolute inset-0 z-0">
              <img
                src={hero1} // Replace with your image path
                alt=""
                className="w-full h-full object-cover opacity-10"
              />
            </div>

            {/* Content */}
            <div className="relative z-10">
              <h3 className="text-xl font-bold mb-3">Our Newsletters</h3>
              <p className="mb-4 text-sm">
                Subscribe to our newsletter for exclusive deals on everyday essentials, new home appliance arrivals, and weekly discounts straight to your inbox.
              </p>
              <form onSubmit={handleAppointmentSubmit}>
                <input
                  onChange={handleAppointmentChange}
                  value={appointmentdata.email}
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  className="w-full p-3 rounded-md bg-white text-gray-800 mb-3 border-0 outline-none focus:outline-none focus:ring-2 focus:ring-orange-500"
                />
                <button
                  type="submit"
                  className="w-full p-3 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors"
                >
                  Submit Button
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Contact Info Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-[#F5F8F8] p-6 rounded-lg flex items-start gap-4">
            <FaPhone className="text-orange-500 text-xl mt-1" />
            <div>
              <h4 className="font-bold">+1 (317) 245-6309</h4>

            </div>
          </div>

          <div className="bg-[#F5F8F8] p-6 rounded-lg flex items-start gap-4">
            <FaEnvelope className="text-orange-500 text-xl mt-1" />
            <div>
              <h4 className="font-bold">info@vitalsourcewholesalellc.com</h4>

            </div>
          </div>


        </div>


      </div>
      <Toaster />
    </div>
  );
};

export default Contact;